import {
  BuildGooglePlacesAutocompleteRequestArgs,
  GooglePlacesAutocompleteRequestType,
} from '@marketplace-web/domain/google-places-data'

const buildComponentRestrictions = (country: string | undefined) => {
  if (!country) return undefined

  return { country }
}

export const buildGooglePlacesAutocompleteRequest = ({
  value,
  country,
  sessionToken,
  type = GooglePlacesAutocompleteRequestType.Geocode,
}: BuildGooglePlacesAutocompleteRequestArgs): google.maps.places.AutocompletionRequest => ({
  input: value || '',
  sessionToken: sessionToken || {},
  types: [type],
  componentRestrictions: buildComponentRestrictions(country),
})
